import React from 'react';
import {IconProps} from './types';

export const Tickets: React.FC<IconProps> = ({ 
    className, 
    width = 20, 
    height = 20, 
    fill = '#212121' 
}) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width={width} 
        height={height} 
        viewBox="0 0 20 20" 
        fill="none"
        className={className}
    >
        <path 
            d="M20.0012 0.72574V19.2742C20.0009 19.4665 19.9244 19.651 19.7884 19.787C19.6525 19.9231 19.4682 19.9996 19.2759 20H0.725292C0.532938 20 0.348438 19.9235 0.212423 19.7874C0.0764086 19.6513 0 19.4666 0 19.2742V0.72574C0 0.533248 0.0764086 0.348688 0.212423 0.212576C0.348438 0.0764635 0.532938 0 0.725292 0H19.2759C19.4682 0.0003167 19.6525 0.0768976 19.7884 0.212941C19.9244 0.348985 20.0009 0.533346 20.0012 0.72574ZM1.45055 18.5484H18.5494V1.45155H1.45296L1.45055 18.5484Z" 
            fill={fill}
        />
        <path 
            d="M8.63794 3.44141H3.25586V8.82736H8.63794V3.44141Z" 
            fill={fill}
        />
        <path 
            d="M9.4497 12.7119H6.42773V15.736H9.4497V12.7119Z" 
            fill={fill}
        />
        <path 
            d="M15.4946 12.7119H12.4727V15.736H15.4946V12.7119Z" 
            fill={fill}
        />
        <path 
            d="M12.4712 9.6875H9.44922V12.7116H12.4712V9.6875Z" 
            fill={fill}
        />
        <path 
            d="M15.5389 6.66406H12.4727V9.68819H15.5389V6.66406Z" 
            fill={fill}
        />
        <path 
            d="M18.5623 0.910156H15.4961V3.93429H18.5623V0.910156Z" 
            fill={fill}
        />
        <path 
            d="M6.45602 18.6452L0.412109 18.6548V15.6307L6.45722 15.6211L6.45602 18.6452Z" 
            fill={fill}
        />
    </svg>
);